import React, {FC} from "react"

import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Slider from "@irati/ui/src/Slider"
import {IconTypes} from "@irati/ui/src/Icon"
import IconButton from "@irati/ui/src/Button/IconButton"

import {SliderContainer, ArrowsWrapper} from "./styled"

interface Props extends InjectIntl {
  id?: string
  onChange?: () => void
}

const SLIDER_SETTINGS = {
  arrows: false,
  dots: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  infinite: true,
  pauseOnHover: false
}

const SliderInfo: FC<Props> = (props) => {
  const {onChange} = props

  const sliderRef = React.useRef<Slider>(null)
  const idNamespace = id("slider-info", props)

  const pause = (element: any) => {
    return element.current?.slickPause()
  }

  const prev = (element: any) => {
    return element.current?.slickPrev()
  }

  const next = (element: any) => {
    return element.current?.slickNext()
  }

  const handleClick = (element: Slider | null, isPrev: boolean) => {
    if (element && element.slickSlider) {
      if (onChange) {
        onChange()
      }
      pause(element.slickSlider)
      return isPrev ? prev(element.slickSlider) : next(element.slickSlider)
    }
  }

  return (
    <SliderContainer>
      <ArrowsWrapper>
        <IconButton icon={IconTypes.arrowLeft} onClick={() => handleClick(sliderRef?.current, true)} aria-label="Left arrow key" />
        <IconButton icon={IconTypes.arrowRight} onClick={() => handleClick(sliderRef?.current, false)} aria-label="Right arrow key" />
      </ArrowsWrapper>
      <Slider id={idNamespace} ref={sliderRef} settings={SLIDER_SETTINGS}>
        {props.children}
      </Slider>
    </SliderContainer>
  )
}

export default injectIntl(SliderInfo)
